import { render, staticRenderFns } from "./BasketRu.vue?vue&type=template&id=17aa9072&scoped=true&"
import script from "./BasketRu.vue?vue&type=script&setup=true&lang=js&"
export * from "./BasketRu.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aa9072",
  null
  
)

export default component.exports